import React from 'react';
import BuildingForm, { BuildingFormProps } from './BuildingForm';

type Props = Omit<BuildingFormProps, "tool">

const FastBuildingForm : React.FC<Props> = ({ ...args }) => <BuildingForm tool="FAST" {...args} />

export default FastBuildingForm;
